
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/information-age",
      function () {
        return require("private-next-pages/archive/information-age.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/information-age"])
      });
    }
  